"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4964],{

/***/ 69862:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);



var ClientOnlyComponent = function ClientOnlyComponent(_ref) {
  var children = _ref.children;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(),
      inBrowser = _useState[0],
      setInBrowser = _useState[1];

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    setInBrowser(true);
  }, []);

  if (!inBrowser) {
    return null;
  }

  return Array.isArray(children) ? children.map(function (child, index) {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
      children: child
    }, index);
  }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
    children: children
  }, "unique");
};

/* harmony default export */ __webpack_exports__["Z"] = (ClientOnlyComponent);

/***/ }),

/***/ 55448:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);



var AppStoreButton = function AppStoreButton(_ref) {
  var store = _ref.store,
      type = _ref.type,
      grow = _ref.grow;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
    target: "_blank",
    href: store === "apple" ? "https://apps.apple.com/us/app/datamynt-point-of-sale-pos/id1572840222" : "https://play.google.com/store/apps/details?id=com.datamynt&hl=en&gl=US",
    rel: "noreferrer",
    className: "px-6 py-4 flex flex-grow ".concat(grow ? "flex flex-1" : "min-w-[10.5rem] md:max-w-[12rem]", " rounded-full ").concat(type === "dark" ? "bg-[#292B36]" : "bg-white", " flex items-center justify-center space-x-2"),
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
      children: store === "apple" ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "25",
        height: "24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
          d: "M18.017 12.556c-.01-1.599.715-2.804 2.178-3.692-.818-1.172-2.056-1.816-3.687-1.94-1.545-.122-3.235.9-3.853.9-.654 0-2.15-.858-3.326-.858C6.9 7.003 4.32 8.902 4.32 12.764c0 1.142.209 2.32.626 3.534.558 1.599 2.569 5.515 4.667 5.452 1.096-.026 1.872-.778 3.3-.778 1.385 0 2.102.778 3.325.778 2.117-.03 3.935-3.59 4.465-5.194-2.838-1.338-2.686-3.919-2.686-4Zm-2.463-7.149c1.188-1.41 1.08-2.695 1.045-3.157-1.05.06-2.264.715-2.955 1.519-.762.862-1.21 1.929-1.114 3.131 1.135.087 2.17-.497 3.024-1.493Z",
          fill: type !== "dark" ? "#292B36" : "white"
        })
      }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "25",
        height: "24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
          d: "M4.109 1.814 14.292 12 4.11 22.186a.997.997 0 0 1-.61-.92V2.734a1 1 0 0 1 .609-.92Zm10.89 10.893 2.302 2.302-10.937 6.333 8.635-8.635Zm3.199-3.198 2.807 1.626a1 1 0 0 1 0 1.73l-2.808 1.626L15.706 12l2.492-2.491ZM6.364 2.658 17.302 8.99l-2.303 2.303-8.635-8.635Z",
          fill: type !== "dark" ? "#292B36" : "white"
        })
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
      className: "text-xs lg:text-base font-semibold ".concat(type !== "dark" ? "text-[#292B36]" : "text-white"),
      children: store === "apple" ? "App Store" : "Google Play"
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (AppStoreButton);

/***/ }),

/***/ 94964:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ landing_Container; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/landing/Nav.jsx + 4 modules
var Nav = __webpack_require__(12158);
// EXTERNAL MODULE: ./node_modules/datamynt-ui-library/lib/index.esm.js
var index_esm = __webpack_require__(21627);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react-icons/fa/index.esm.js
var fa_index_esm = __webpack_require__(89583);
// EXTERNAL MODULE: ./node_modules/react-icons/fi/index.esm.js
var fi_index_esm = __webpack_require__(86893);
// EXTERNAL MODULE: ./components/landing/AppStoreButton.jsx
var AppStoreButton = __webpack_require__(55448);
// EXTERNAL MODULE: ./helpers/twBreakpoints.js
var twBreakpoints = __webpack_require__(97971);
// EXTERNAL MODULE: ./components/ClientOnlyComponent.jsx
var ClientOnlyComponent = __webpack_require__(69862);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/landing/Footer.jsx












var Footer = function Footer() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(ClientOnlyComponent/* default */.Z, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("footer", {
      className: "bg-[#141518] text-white w-full space-y-4 flex flex-col items-center",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "grid grid-cols-1 lg:grid-cols-4 w-full lg:w-5/6 gap-12 px-8 py-8 lg:px-0",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "flex flex-col space-y-8 lg:col-span-3",
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col space-y-4",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h6", {
              className: "font-semibold",
              children: "Available In:"
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "grid w-full md:w-3/4 grid-cols-4 md:grid-cols-7 gap-4 justify-items-center",
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "w-full space-y-2 flex flex-col items-start",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  className: "relative w-full h-10",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                    layout: "fill",
                    objectFit: "contain",
                    alt: "Digifinex",
                    src: "/nigerianew.png"
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                  className: "text-xs text-center w-full",
                  children: "Nigeria"
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "w-full space-y-2 flex flex-col items-start",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  className: "relative w-full h-10",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                    layout: "fill",
                    objectFit: "contain",
                    alt: "Digifinex",
                    src: "/kenyanew.png"
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                  className: "text-xs text-center w-full",
                  children: "Kenya"
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "w-full space-y-2 flex flex-col items-start",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  className: "relative w-full h-10",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                    width: 80,
                    height: 100,
                    layout: "fill",
                    objectFit: "contain",
                    alt: "Digifinex",
                    src: "/mexiconew.png"
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                  className: "text-xs text-center w-full",
                  children: "Mexico"
                })]
              })]
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col space-y-4",
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "flex flex-col space-y-2",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: "font-semibold text-sm",
                children: "Nigeria Address"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: "text-sm",
                children: "21, Ajanaku Street, Awuse Estate, Off Salvation Road, Opebi, Ikeja Lagos, Nigeria"
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "flex flex-col space-y-2",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: "font-semibold text-sm",
                children: "Kenya Address"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: "text-sm",
                children: "PineTree Plaza, 7th Floor, Kaburu Drive, Kilimani, P.O. Box 59162-00200, Nairobi, Kenya"
              })]
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col space-y-2",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Logo */.TR, {}), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              className: "text-sm",
              children: "DataMynt, Inc. is a financial technology company, not a bank."
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
            className: "flex flex-wrap list-none",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              className: "flex justify-start mr-4",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                href: "/aboutus",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  className: "text-white font-semibold",
                  children: "Team"
                })
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              className: "flex justify-start mr-4",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                href: "/contactus",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  className: "text-white font-semibold",
                  children: "Contact"
                })
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              className: "flex justify-start mr-4",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                href: "https://angel.co/company/cryptopayments_/jobs",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  className: "text-white font-semibold",
                  target: "_blank",
                  rel: "noreferrer",
                  children: "Careers"
                })
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              className: "flex justify-start mr-4",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                href: "/login",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  className: "text-white font-semibold",
                  target: "_blank",
                  rel: "noreferrer",
                  children: "Login"
                })
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              className: "flex justify-start mr-4",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                href: "/terms",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  className: "text-white font-semibold",
                  target: "_blank",
                  rel: "noreferrer",
                  children: "Terms & Conditions"
                })
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
              className: "flex justify-start mr-4",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                href: "/faq",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  className: "text-white font-semibold",
                  target: "_blank",
                  rel: "noreferrer",
                  children: "FAQ"
                })
              })
            })]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "w-full flex flex-col space-y-8 justify-between",
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col space-y-4",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h6", {
              className: "font-semibold",
              children: "Download from:"
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "relative flex lg:flex-col space-x-2 lg:space-x-0 lg:space-y-4",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(AppStoreButton/* default */.Z, {
                grow: (0,twBreakpoints/* default */.Z)("md"),
                type: "light",
                store: "apple"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(AppStoreButton/* default */.Z, {
                grow: (0,twBreakpoints/* default */.Z)("md"),
                type: "light",
                store: "google"
              })]
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col space-y-4 w-full",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              className: "text-sm",
              children: "Email: sales@datamynt.com"
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
              className: "flex space-x-2 list-none",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                href: "mailto:sales@datamynt.com",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  className: "w-8 md:h-8 flex items-center justify-center text-white bg-[#0051FE] rounded-full p-2",
                  target: "_blank",
                  rel: "noreferrer",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(fi_index_esm/* FiMail */.Imn, {})
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                href: "https://www.linkedin.com/company/datamynt/",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  className: "w-8 md:h-8 flex items-center justify-center text-white bg-[#0051FE] rounded-full p-2",
                  target: "_blank",
                  rel: "noreferrer",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(fa_index_esm/* FaLinkedinIn */.BUd, {})
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                href: "https://twitter.com/DataMynt",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                  className: "w-8 md:h-8 flex items-center justify-center text-white bg-[#0051FE] rounded-full p-2 mr-8",
                  target: "_blank",
                  rel: "noreferrer",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(fa_index_esm/* FaTwitter */.fWC, {})
                })
              })]
            })]
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: "bg-[#0051FE] w-full text-white text-center py-2",
        children: "2022 Data\xA0Mynt, Inc. All Rights Reserved."
      })]
    })
  });
};

/* harmony default export */ var landing_Footer = (Footer);
// EXTERNAL MODULE: ./contexts/Landing/index.js
var Landing = __webpack_require__(493);
;// CONCATENATED MODULE: ./components/landing/Container.jsx







var Container = function Container(_ref) {
  var children = _ref.children,
      initialStateFromProps = _ref.initialStateFromProps,
      onCurrencyChangeNaira = _ref.onCurrencyChangeNaira,
      onCurrencyShelling = _ref.onCurrencyShelling;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Landing/* LandingProvider */.x, {
    initialStateFromProps: initialStateFromProps,
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "containerLayout w-full flex flex-col",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Nav/* default */.Z, {
        onCurrencyChangeNaira: onCurrencyChangeNaira,
        onCurrencyChangeShelling: onCurrencyShelling
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "relative flex-grow",
        children: children
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(landing_Footer, {})]
    })
  });
};

/* harmony default export */ var landing_Container = (Container);

/***/ }),

/***/ 12158:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ landing_Nav; }
});

// EXTERNAL MODULE: ./node_modules/datamynt-ui-library/lib/index.esm.js
var index_esm = __webpack_require__(21627);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-icons/hi/index.esm.js
var hi_index_esm = __webpack_require__(53854);
;// CONCATENATED MODULE: ./hooks/useClickListener.jsx


var useClickListener = function useClickListener(elementId) {
  var deactivateAlsoOnElementClicked = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var _useState = (0,react.useState)(false),
      elementActive = _useState[0],
      setElementActive = _useState[1];

  var prevElementState = (0,react.useRef)(false);
  (0,react.useEffect)(function () {
    var isElementChild = function isElementChild(target) {
      return target.closest("#".concat(elementId));
    };

    function closeElement(e) {
      var target = e.target;

      if (!isElementChild(target)) {
        setElementActive(false);
      } else {
        if (deactivateAlsoOnElementClicked) {
          setElementActive(!prevElementState.current ? true : false);
        } else {
          !prevElementState.current && setElementActive(true);
        }
      }
    }

    window.addEventListener("click", closeElement);
    return function () {
      window.removeEventListener("click", elementActive);
    };
  }, [elementId, setElementActive, deactivateAlsoOnElementClicked]);
  (0,react.useEffect)(function () {
    prevElementState.current = elementActive;
  });
  return elementActive;
};

/* harmony default export */ var hooks_useClickListener = (useClickListener);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/listbox/listbox.js + 4 modules
var listbox = __webpack_require__(54601);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/transitions/transition.js + 5 modules
var transition = __webpack_require__(17106);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/20/solid/ChevronUpDownIcon.js
var ChevronUpDownIcon = __webpack_require__(29645);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/landing/ExchangeRates.jsx






var currency = [{
  name: "NIGERIAN NAIRA- NGN",
  value: "NGN"
}, {
  name: "KENYAN SHILLING - KES",
  value: "KES"
}];
function ExchangeRates(props) {
  var _useState = (0,react.useState)(currency[0]),
      selected = _useState[0],
      setSelected = _useState[1];

  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(listbox/* Listbox */.R, {
      value: selected,
      onChange: setSelected,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(listbox/* Listbox.Button */.R.Button, {
        className: "relative cursor-default rounded-lg bg-transparent py-2  pr-10 text-left sm:text-sm",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          children: selected.name
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: "pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(ChevronUpDownIcon, {
            className: "h-5 w-5 text-gray-400",
            "aria-hidden": "true"
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(transition/* Transition */.u, {
        as: react.Fragment,
        leave: "transition ease-in duration-100",
        leaveFrom: "opacity-100",
        leaveTo: "opacity-0",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(listbox/* Listbox.Options */.R.Options, {
          className: "lg:absolute mt-1 rounded-md bg-white text-black py-1 text-base shadow-lg  sm:text-sm",
          children: currency.map(function (person, personIdx) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)(listbox/* Listbox.Option */.R.Option, {
              className: function className(_ref) {
                var active = _ref.active;
                return "relative cursor-default select-none py-2 pl-4 pr-2 ".concat(active ? "bg-amber-100 text-amber-900" : "text-gray-900");
              },
              value: person,
              children: function children(_ref2) {
                var selected = _ref2.selected;
                return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    onClick: function onClick() {
                      if (person.value === "NGN") {
                        props.onCurrencyChangeShelling("NGN");
                      }

                      if (person.value === "KES") {
                        props.onCurrencyChangeShelling("KSH");
                      }
                    },
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                      className: "block truncate ".concat(selected ? "font-medium" : "font-normal"),
                      children: person.name
                    })
                  })
                });
              }
            }, personIdx);
          })
        })
      })]
    })
  });
}
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/menu/menu.js + 2 modules
var menu = __webpack_require__(40414);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/20/solid/ChevronDownIcon.js
var ChevronDownIcon = __webpack_require__(24819);
;// CONCATENATED MODULE: ./components/landing/NavDropdownCustomers.jsx






function classNames() {
  for (var _len = arguments.length, classes = new Array(_len), _key = 0; _key < _len; _key++) {
    classes[_key] = arguments[_key];
  }

  return classes.filter(Boolean).join(" ");
}

function NavBarCustomer() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(menu/* Menu */.v, {
    as: "div",
    className: "relative inline-block text-left ",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(menu/* Menu.Button */.v.Button, {
      className: "inline-flex w-full  gap-x-1.5 rounded-md bg-transparent  py-2 text-sm font-semibold text-BLACK  ",
      children: ["Customers", /*#__PURE__*/(0,jsx_runtime.jsx)(ChevronDownIcon, {
        className: "-mr-1 h-5 w-5 text-gray-400",
        "aria-hidden": "true"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: "text-white lg:hidden",
        children: "Customers"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(transition/* Transition */.u, {
      as: react.Fragment,
      enter: "transition ease-out duration-100",
      enterFrom: "transform opacity-0 scale-95",
      enterTo: "transform opacity-100 scale-100",
      leave: "transition ease-in duration-75",
      leaveFrom: "transform opacity-100 scale-100",
      leaveTo: "transform opacity-0 scale-95",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(menu/* Menu.Items */.v.Items, {
        className: "lg:absolute right-0 z-10 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none text-black ",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "py-1",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(menu/* Menu.Item */.v.Item, {
            children: function children(_ref) {
              var active = _ref.active;
              return /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                href: "#",
                className: classNames(active ? "bg-gray-100 text-white" : "text-gray-700", "block px-4 py-2 text-sm"),
                children: "Importers"
              });
            }
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(menu/* Menu.Item */.v.Item, {
            children: function children(_ref2) {
              var active = _ref2.active;
              return /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                href: "#",
                className: classNames(active ? "bg-gray-100 text-white" : "text-gray-700", "block px-4 py-2 text-sm"),
                children: "Retail"
              });
            }
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(menu/* Menu.Item */.v.Item, {
            children: function children(_ref3) {
              var active = _ref3.active;
              return /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                href: "#",
                className: classNames(active ? "bg-gray-100 text-white" : "text-gray-700", "block px-4 py-2 text-sm"),
                children: "Ecommerce"
              });
            }
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(menu/* Menu.Item */.v.Item, {
            children: function children(_ref4) {
              var active = _ref4.active;
              return /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                href: "#",
                className: classNames(active ? "bg-gray-100 text-white" : "text-gray-700", "block px-4 py-2 text-sm"),
                children: "Real Estate"
              });
            }
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(menu/* Menu.Item */.v.Item, {
            children: function children(_ref5) {
              var active = _ref5.active;
              return /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                href: "#",
                className: classNames(active ? "bg-gray-100 text-white" : "text-gray-700", "block px-4 py-2 text-sm"),
                children: "Travel"
              });
            }
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(menu/* Menu.Item */.v.Item, {
            children: function children(_ref6) {
              var active = _ref6.active;
              return /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                href: "#",
                className: classNames(active ? "bg-gray-100 text-white" : "text-gray-700", "block px-4 py-2 text-sm"),
                children: "Hospitality"
              });
            }
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(menu/* Menu.Item */.v.Item, {
            children: function children(_ref7) {
              var active = _ref7.active;
              return /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                href: "#",
                className: classNames(active ? "bg-gray-100 text-white" : "text-gray-700", "block px-4 py-2 text-sm"),
                children: "Gaming"
              });
            }
          })]
        })
      })
    })]
  });
}
;// CONCATENATED MODULE: ./components/landing/NavDropdownProduct.jsx






function NavDropdownProduct_classNames() {
  for (var _len = arguments.length, classes = new Array(_len), _key = 0; _key < _len; _key++) {
    classes[_key] = arguments[_key];
  }

  return classes.filter(Boolean).join(" ");
}

function NavBarProduct() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(menu/* Menu */.v, {
    as: "div",
    className: "relative inline-block text-left w-auto",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(menu/* Menu.Button */.v.Button, {
      className: "inline-flex gap-x-1.5 rounded-md bg-transparent  py-2 text-sm font-semibold text-BLACK ",
      children: ["Fiat Deposit and Withdrawal", /*#__PURE__*/(0,jsx_runtime.jsx)(ChevronDownIcon, {
        className: "-mr-1 h-5 w-5 text-gray-400",
        "aria-hidden": "false"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(transition/* Transition */.u, {
      as: react.Fragment,
      enter: "transition ease-out duration-100",
      enterFrom: "transform opacity-0 scale-95",
      enterTo: "transform opacity-100 scale-100",
      leave: "transition ease-in duration-75",
      leaveFrom: "transform opacity-100 scale-100",
      leaveTo: "transform opacity-0 scale-95",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(menu/* Menu.Items */.v.Items, {
        className: "lg:absolute right-0 z-10 mt-2 w-25 lg:w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none text-black ",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "py-1",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(menu/* Menu.Item */.v.Item, {
            children: function children(_ref) {
              var active = _ref.active;
              return /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                href: "#",
                className: NavDropdownProduct_classNames(active ? "bg-gray-100 text-white" : "text-gray-700", "block px-4 py-2 text-sm"),
                children: "Product"
              });
            }
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(menu/* Menu.Item */.v.Item, {
            children: function children(_ref2) {
              var active = _ref2.active;
              return /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                href: "#",
                className: NavDropdownProduct_classNames(active ? "bg-gray-100 text-white" : "text-gray-700", "block px-4 py-2 text-sm"),
                children: "Multi Currency"
              });
            }
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(menu/* Menu.Item */.v.Item, {
            children: function children(_ref3) {
              var active = _ref3.active;
              return /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                href: "#",
                className: NavDropdownProduct_classNames(active ? "bg-gray-100 text-white" : "text-gray-700", "block px-4 py-2 text-sm"),
                children: "Point of Sale"
              });
            }
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(menu/* Menu.Item */.v.Item, {
            children: function children(_ref4) {
              var active = _ref4.active;
              return /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                href: "#",
                className: NavDropdownProduct_classNames(active ? "bg-gray-100 text-white" : "text-gray-700", "block px-4 py-2 text-sm"),
                children: "Online Checkout"
              });
            }
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(menu/* Menu.Item */.v.Item, {
            children: function children(_ref5) {
              var active = _ref5.active;
              return /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                href: "#",
                className: NavDropdownProduct_classNames(active ? "bg-gray-100 text-white" : "text-gray-700", "block px-4 py-2 text-sm"),
                children: "Currency Exchange"
              });
            }
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(menu/* Menu.Item */.v.Item, {
            children: function children(_ref6) {
              var active = _ref6.active;
              return /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                href: "#",
                className: NavDropdownProduct_classNames(active ? "bg-gray-100 text-white" : "text-gray-700", "block px-4 py-2 text-sm"),
                children: "OTC"
              });
            }
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(menu/* Menu.Item */.v.Item, {
            children: function children(_ref7) {
              var active = _ref7.active;
              return /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                href: "#",
                className: NavDropdownProduct_classNames(active ? "bg-gray-100 text-white" : "text-gray-700", "block px-4 py-2 text-sm"),
                children: "Fiat Deposit and Withdrawal"
              });
            }
          }), " ", /*#__PURE__*/(0,jsx_runtime.jsx)(menu/* Menu.Item */.v.Item, {
            children: function children(_ref8) {
              var active = _ref8.active;
              return /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                href: "#",
                className: NavDropdownProduct_classNames(active ? "bg-gray-100 text-white" : "text-gray-700", "block px-4 py-2 text-sm"),
                children: "Currency Exchange"
              });
            }
          }), " ", /*#__PURE__*/(0,jsx_runtime.jsx)(menu/* Menu.Item */.v.Item, {
            children: function children(_ref9) {
              var active = _ref9.active;
              return /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                href: "#",
                className: NavDropdownProduct_classNames(active ? "bg-gray-100 text-white" : "text-gray-700", "block px-4 py-2 text-sm"),
                children: "Working Capital Loans"
              });
            }
          })]
        })
      })
    })]
  });
}
;// CONCATENATED MODULE: ./components/landing/Nav.jsx













var navStyles = "bg-[#141518] top-0 left-0 text-white p-6 md:px-8 sm:py-8 w-full z-50";

var Nav = function Nav(_ref) {
  var onCurrencyChangeShelling = _ref.onCurrencyChangeShelling,
      onCurrencyChangeNaira = _ref.onCurrencyChangeNaira;
  var router = (0,next_router.useRouter)();
  var dropdownActive = hooks_useClickListener("dm__nav_dropdown_menu", false);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("nav", {
      className: "".concat(navStyles, " bg-[#141518] hidden md:flex justify-between"),
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
        href: "/",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          className: "flex items-center",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Logo */.TR, {
            type: "DmDefaultFullColor"
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        className: "flex items-center text-md md:space-x-2 lg:space-x-8 ",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
            href: "/",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              className: /contactus/.test(router.pathname) ? "text-primary" : "text-white hover:text-primary ml-2",
              children: "Home"
            })
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
            href: "/aboutus",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              className: /aboutus/.test(router.pathname) ? "text-primary" : "text-white hover:text-primary",
              children: "About us"
            })
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
            href: "/agents",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              className: /agents/.test(router.pathname) ? "text-primary" : "text-white hover:text-primary hidden lg:block ",
              children: "Become An Agent"
            })
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(NavBarCustomer, {})
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(NavBarProduct, {})
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(ExchangeRates, {
            onCurrencyChangeNaira: onCurrencyChangeNaira,
            onCurrencyChangeShelling: onCurrencyChangeShelling
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
        href: "/login",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          target: "_blank",
          rel: "noreferrer",
          className: "hover:shadow-blue py-2 px-8 rounded-full text-white border-white border",
          children: "Login"
        }, "1")
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("nav", {
      className: "".concat(navStyles, " flex justify-between items-center md:hidden"),
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
        href: "/",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* Logo */.TR, {
            type: "DmDefaultFullColor"
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        id: "dm__nav_dropdown_menu",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(hi_index_esm/* HiOutlineMenu */.otZ, {
          size: 20
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
          className: "".concat(dropdownActive ? "flex flex-col" : "hidden", " bg-white text-black  rounded-b-2xl space-y-4 absolute top-12 right-8 py-4 px-6 z-50"),
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
              src: "/Vectorlogo.svg",
              height: 50,
              width: 50,
              alt: ""
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
            className: "static",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(ExchangeRates, {
              onCurrencyChangeNaira: onCurrencyChangeNaira,
              onCurrencyChangeShelling: onCurrencyChangeShelling
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
              href: "/",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                children: "Home"
              })
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
            className: "static",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(NavBarCustomer, {})
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
            className: "static",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(NavBarProduct, {})
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
              href: "/aboutus",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                className: "".concat(/aboutus/.test(router.pathname) ? "text-primary" : "", " hover:text-byob"),
                children: "About Us"
              })
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
              href: "/contactus",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                className: "".concat(/contactus/.test(router.pathname) ? "text-primary" : "", " hover:text-byob"),
                children: "Contact us"
              })
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
              href: "/contactus",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                className: "hover:text-byob",
                target: "_blank",
                rel: "noreferrer",
                children: "BYOB"
              }, "1")
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
              href: "/agents",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                className: "hover:text-byob",
                target: "_blank",
                rel: "noreferrer",
                children: "Become An Agent"
              }, "1")
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
              href: "https://angel.co/company/cryptopayments_/jobs",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                target: "_blank",
                rel: "noreferrer",
                className: "hover:text-byob",
                children: "Careers"
              })
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
              href: "https://zfrmz.com/bukVz5q3SzM18DSnC4PM",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                target: "_blank",
                rel: "noreferrer",
                className: "bg-black rounded-2xl p-2 text-white px-5 mr-3",
                children: "SIGN UP"
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
              href: "/login",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                target: "_blank",
                rel: "noreferrer",
                className: "bg-gray-50 rounded-2xl p-2 text-black px-5",
                children: "SIGN IN"
              })
            })]
          })]
        })]
      })]
    })]
  });
};

/* harmony default export */ var landing_Nav = (Nav);

/***/ }),

/***/ 493:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ LandingContext; },
/* harmony export */   "x": function() { return /* binding */ LandingProvider; }
/* harmony export */ });
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_opt_build_repo_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var initialState = {
  articlePage: false
};

var reducer = function reducer(state, action) {
  var newState;
  var callbacks = {
    SET_ARTICLE_PAGE: function SET_ARTICLE_PAGE() {
      newState = _objectSpread(_objectSpread({}, state), {}, {
        articlePage: action.value
      });
    }
  };
  callbacks[action.type]();
  return newState;
};

var LandingContext = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({
  state: initialState,
  dispatch: function dispatch() {}
});

var LandingProvider = function LandingProvider(_ref) {
  var children = _ref.children,
      initialStateFromProps = _ref.initialStateFromProps;

  var _useReducer = (0,react__WEBPACK_IMPORTED_MODULE_1__.useReducer)(reducer, initialStateFromProps || initialState),
      state = _useReducer[0],
      dispatch = _useReducer[1];

  var memoizedState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function () {
    return {
      state: state,
      dispatch: dispatch
    };
  }, [state, dispatch]);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(LandingContext.Provider, {
    value: memoizedState,
    children: children
  });
};



/***/ }),

/***/ 97971:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

var isTailwindBreakpoint = function isTailwindBreakpoint(breakpoint) {
  try {
    var breakpoints = {
      xs: 319,
      sm: 640,
      md: 768,
      lg: 1024,
      xl: 1280,
      "2xl": 1536
    };
    return window.innerWidth <= breakpoints[breakpoint];
  } catch (e) {}
};

/* harmony default export */ __webpack_exports__["Z"] = (isTailwindBreakpoint);

/***/ })

}]);